import { Navigate, Route, Routes } from 'react-router-dom';
import { Inbox } from './routes/Inbox';
import { SourceDetail } from './routes/SourceDetail';
import { Login } from './routes/Login';
import { Shared } from './routes/Shared';
import { Productions } from './routes/Productions';
import { ProductionDetail } from './routes/ProductionDetail';

/**
 * Auth here is cookie-based (`.nightshade.gameonsolutions.uk` session). We
 * can't check the cookie synchronously from JS (HttpOnly), so the routes
 * just call the API and let `lib/api.redirectToLogin()` bounce on 401.
 *
 * /login is kept as a friendly entry point for "sign in" CTAs but it's not
 * required — every other route handles the redirect itself.
 */
export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/shared" element={<Shared />} />
      <Route path="/" element={<Inbox />} />
      <Route path="/source/:id" element={<SourceDetail />} />
      <Route path="/productions" element={<Productions />} />
      <Route path="/productions/:id" element={<ProductionDetail />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
